<template>
  <div>

    <el-row :gutter="12">
      <el-col :span="12">
        <p class="note">订单号:{{ orderId }}</p>
      </el-col>
      <el-col :span="12">
        <p class="note">任务类型:{{ $actionType.get(type) }}</p>
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :span="12">
        <p class="note">待领取:{{ tj.waitNum }}</p>
      </el-col>
      <el-col :span="12">
        <p class="note">累计推送人数:{{ tj.trNum }}</p>
      </el-col>
    </el-row>

<hr>

    <avue-crud :option="trOption" :data="trData" :page.sync="page" :search.sync="searchForm"
               @size-change="sizeChange" @current-change="currentChange" @search-change="searchChange"
               ref="crud" highlight-current>

      <template slot="pushTime" slot-scope="scope">
        <span>{{ formatDate(scope.row.pushTime) }}</span>
      </template>

    </avue-crud>

  </div>


</template>

<script>
import {pushDetailTj,pushDetailTr} from '@/api/dot/order'
import {formatDate} from '@/util/date'

export default {
  props: ['type', 'orderId', 'pm',],
  data() {
    return {
      loading: false,
      trData: [],
      tj: {
        trNum: 0,
        waitNum: 0,
      },
      page: {
        pageSize: 20,
        pagerCount: 5,
        currentPage: 1,
        total: 0,
      },
      searchForm: {},
      trOption: {
        page: true,
        columnBtn: false,
        refreshBtn: false,
        border: true,
        saveBtn: false,
        updateBtn: false,
        cancelBtn: false,
        viewBtn: false,
        addBtn: false, //新增按钮
        delBtn: false,
        editBtn: false,
        menu: false,
        expand: false, //子表格
        menuWidth: 120,
        searchMenuSpan:4,
        searchShowBtn:false,
        align: 'center',
        menuAlign: 'center',
        searchMenuPosition: 'right', //当前版本不支持
        column: [{
          label: '译员ID',
          prop: 'trId',
        }, {
          label: '译员昵称',
          prop: 'nickName',
        }, {
          label: '手机号',
          prop: 'phone',
          search: true
        }, {
          label: '推送时间',
          prop: 'pushTime',
          slot:true
        },]
      }
    }
  },
  watch:{
    'type': function (n, o) {
      if(n!==0){
        this.init()
      }

    },
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      pushDetailTj(this.orderId, this.type).then(res => {
        this.tj = res.data.data
      })
      this.getPage(this.page,this.searchForm);
    },
    formatDate(time) {
      if (time) {
        let date = new Date(parseFloat(time))
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }

    },
    getPage: function (page, params) {
      pushDetailTr(Object.assign({
        current: page.currentPage,
        size: page.pageSize
      }, params, {orderId: this.orderId,taskType:this.type})).then(response => {
         console.log(response)
        this.trData = response.data.data.records
        this.page.total = response.data.data.total
      })
    },
    searchChange(params, done) {
      this.searchForm = params
      this.page.currentPage = 1
      this.getPage(this.page, this.searchForm)
      done();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.page.currentPage = 1
      this.getPage(this.page, this.searchForm)
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
      this.getPage(this.page, this.searchForm)
    },

  }
}

</script>

